import React, { createContext, useReducer, ReactNode, Dispatch } from 'react';
import Reducer, { State, Action } from '../../reducers/regform-fields/password-field-reducer';

type PasswordFieldContextType = [State, Dispatch<Action>];

const initialState: State = {
	value: '',
	error: {
		message: '',
		show: false,
	},
	valid: null,
};

export const ConfirmPasswordFieldContext = createContext<PasswordFieldContextType>([initialState, () => null]);

interface PasswordFieldStoreProps {
	children: ReactNode;
}

const PasswordFieldStore: React.FC<PasswordFieldStoreProps> = ({ children }) => {
	const [state, dispatch] = useReducer(Reducer, initialState);
	return (
		<ConfirmPasswordFieldContext.Provider value={[state, dispatch]}>
			{children}
		</ConfirmPasswordFieldContext.Provider>
	);
};

export default PasswordFieldStore;
